import { Injectable } from '@angular/core'
import { environment } from '../../../../../environments/environment'
import { HttpClient } from '@angular/common/http'
import { Observable } from 'rxjs'
import { ResponseRequestModel } from '../../../models/response.model'
import {
  CreateTariffModel,
  DeleteTariffModel,
  ImportTariffModel,
  SearchTariffModel,
} from '../../../models/tariff.model'

@Injectable({
  providedIn: 'root',
})
export class TariffService {
  private baseUrl = environment.baseUrl
  private resource: string = 'Tarifario'
  private resourceImport: string = 'ImportFile'

  constructor(private httpClient: HttpClient) {}

  public createTariff(
    // model: CreateTariffModel,
    model: any,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/create`,
      model,
    )
  }

  public createTariffStandard(
    // model: CreateTariffModel,
    model: any,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      'N',
      // `${this.baseUrl}${this.resource}/edit-create/standard`,
      model,
    )
  }

  public createTariffUnique(
    // model: CreateTariffModel,
    model: any,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/create/inactive`,
      model,
    )
  }

  public editTariff(
    model: any,
    // model: EditTariffModel,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/edit`,
      model,
    )
  }

  public deleteTariff(
    model: DeleteTariffModel,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/delete`,
      model,
    )
  }

  public listPagedTariff(
    page: number,
    rows: number = 15,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/default/listpaginated?pageNumber=${page}&pageSize=${rows}`,
    )
  }

  public listPagedTariffClient(
    page: number,
    rows: number = 15,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/Clientes/listpaginated?pageNumber=${page}&pageSize=${rows}`,
    )
  }

  public listPagedTariffClientbyId(
    page: number,
    rows: number = 15,
    clientId: number,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/cliente/listpaginated/${clientId}?pageNumber=${page}&pageSize=${rows}`,
    )
  }

  public listTariff(): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/default/listall`,
    )
  }

  public listTariffClient(): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/cliente/listall`,
    )
  }

  public getTariffbyId(id: number): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/${id}`,
    )
  }

  public searchPagedTariff(
    page: number,
    rows: number = 15,
    model: any,
    // model: SearchTariffModel,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/search-paginated?pageNumber=${page}&pageSize=${rows}`,
      model,
    )
  }

  public searchAllPagedTariff(
    page: number,
    rows: number = 15,
    model: any,
    // model: SearchTariffModel,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/searchall-paginated?pageNumber=${page}&pageSize=${rows}`,
      model,
    )
  }

  public importTariff(
    model: any,
    // model: ImportTariffModel,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resourceImport}/tarifario/excel`,
      model,
    )
  }

  public toggleStatusTariff(
    model: any,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/toggle`,
      model,
    )
  }

  public downloadModelTariff(
  ): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/download-excel`,
    )
  }
}
